import React, { PropsWithChildren } from 'react';
import { TFdrProductRecommendationProps } from 'components/domain/fdr-page-components/recommenders/product/fdr-product-recommendation';
import { IFdrProductRecommenderProduct } from 'components/domain/fdr-page-components/recommenders/product/fdr-product-recommender.types';
import { FdrSearchItem } from 'components/domain/fdr-search/fdr-search-item';

export const B2BStaticGeoRecommendationSliderItem: React.FC<
  PropsWithChildren<TFdrProductRecommendationProps>
> = ({ lazy, updateImageHeight, className, ...rest }) => {
  return (
    <FdrSearchItem
      searchItem={{ ...rest }}
      sectionKey="adventuretravel" // to show bookmark icon
      className={className}
      lazy={lazy}
      getImageHeight={updateImageHeight}
    />
  );
};

export const B2BStaticGeoRecommendationGridItem: React.FC<{
  item: IFdrProductRecommenderProduct;
}> = ({ item }) => {
  return (
    <FdrSearchItem
      key={item.id}
      searchItem={item}
      sectionKey="adventuretravel" // to show bookmark icon
      lazy={false}
    />
  );
};
